import { ProofInterface } from '@graphcommerce/graphql-mesh'
import { i18n } from '@lingui/core'
import ChatMessage from './ChatMessage'

type ChatBoxProps = {
  proofs: ProofInterface[]
}

export function ChatBox(props: ChatBoxProps) {
  const { proofs } = props
  return (
    <div className='w-full overflow-auto border-b-2 border-templi-purple bg-pure-white pb-5'>
      <span className='Type-XL-Bold block w-full bg-5-grey py-2 pl-5'>
        {i18n._('Comment History')}
      </span>
      {(!proofs[0]?.author_comments || proofs[0]?.author_comments.length <= 0) &&
        (!proofs[0]?.comments || proofs[0]?.comments.length <= 0) && (
          <span className='Type-Regular-Regular block w-full px-5 pt-5 text-center italic text-50-grey'>
            No availaible chat history
          </span>
        )}
      {proofs &&
        proofs.length > 0 &&
        proofs.map((proof) => (
          <>
            {proof?.author_comments && proof?.author_comments?.length > 0 && (
              <ChatMessage
                comment={proof.author_comments ?? ''}
                isFromAdmin={proof.author === 'admin'}
                dateTime={proof.date_uploaded}
                author={proof.author}
                id={proof.id}
              />
            )}
            {proof?.comments && proof?.comments?.length > 0 && (
              <ChatMessage
                comment={proof.comments ?? ''}
                isFromAdmin={proof.author !== 'admin'}
                dateTime={proof.date_reviewed ?? ''}
                author='You'
                id={proof.id}
              />
            )}
          </>
        ))}
    </div>
  )
}
